import moment from 'moment';
import { Moment, Duration } from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { joinClasses } from '../../../../Utils/className.util';
// @ts-ignore
import styles from './CaseCountdownBadge.module.scss';
import { convertFromMilliseconds } from '../../../../Helpers/date.helper';

interface Props {
	className?: string;
	solveTo: Moment;
	createdAt: Moment;
	onTimeRunOut: () => void;
}

const CaseCountdownBadge: React.FC<Props> = ({
	className,
	solveTo,
	createdAt,
	onTimeRunOut,
}) => {
	const [duration, setDuration] = useState<Duration | null>(null);
	const [color, setColor] = useState('green');

	const totalDuration = useMemo(() => {
		const duration = moment.duration(solveTo.diff(createdAt));
		return duration.asMilliseconds();
	}, []);

	const calculateTime = () => {
		const duration = moment.duration(solveTo.diff(moment.utc()));
		if (duration.isValid()) {
			setDuration(duration);
		}
		if (duration.asMilliseconds() < totalDuration / 3) {
			setColor('red');
		} else if (duration.asMilliseconds() < (totalDuration / 3) * 2) {
			setColor('orange');
		}
	};

	useEffect(() => {
		calculateTime();
		const interval = setInterval(() => {
			calculateTime();
		}, 1000);
		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		if (duration && duration.asMilliseconds() <= 0) {
			onTimeRunOut();
		}
	}, [duration]);

	const time: string | null = useMemo(() => {
		if (!duration) {
			return null;
		}
		if (duration.asMilliseconds() > 0) {
			const separation = convertFromMilliseconds(duration.asMilliseconds());
			return `${separation.hours}:${separation.minutes}:${separation.seconds}`;
		}
		return '00:00:00';
	}, [duration]);

	if (time) {
		return (
			<div className={joinClasses([className, styles[color]])}>{time}</div>
		);
	}

	return <></>;
};

export default CaseCountdownBadge;
